const isRoverUrl = (url: string): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    url.includes(window.location.hostname) ||
    url.startsWith('/') ||
    url.startsWith('./') ||
    url.startsWith('../')
  );
};

export default isRoverUrl;
